// extracted by mini-css-extract-plugin
export var MuiPaginationUl = "styles-module--MuiPagination-ul--qvjr2";
export var pagination = "styles-module--pagination--sOEye";
export var paginationContainer = "styles-module--paginationContainer--L4AJz";
export var paginationSelect = "styles-module--paginationSelect--reNEv";